import React, {useEffect} from 'react';
import CustomInput from '../components/CustomInput';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector} from 'react-redux';
import {useFormik} from 'formik';
import * as Yup from 'yup';
import { login } from '../features/auth/authSlice';

const schema = Yup.object().shape({
  email: Yup.string().email('Email should be valid').required('Please, Enter your Email'),
  password: Yup.string().required('Please, Enter your Password'),
});

const Login = () => {
  const authState = useSelector((state) => state);
  const {user, isLoading, isError, isSuccess, message} = authState.auth;
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: schema,
    onSubmit: (values) => {
      dispatch(login(values));
    },
  });
  useEffect(() => {
    if (isSuccess) {
      navigate('admin');
    } else {
      navigate('');
    }
  }, [user, isLoading, isError, isSuccess, message]);
  return (
    <div className='py-4' style={{background: '#013476', minHeight: '100vh'}}>
      <div className='nav-logo align-items-center'>
        <a rel="Nile" href="https://a-nile.com/" className="nav-a">
          <svg data-v-fde0c5aa="" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" className="iconAbove" aria-hidden="true" focusable="false" style={{height: '200px', width: '200px'}}><defs data-v-fde0c5aa=""></defs><rect data-v-fde0c5aa="" fill="transparent" x="0" y="0" style={{height: '500px', width: '500px'}} className="logo-background-square"></rect><defs data-v-fde0c5aa=""></defs>
            <g data-v-fde0c5aa="" id="86a1221b-7f9c-4b4b-ae81-248d0df7c96e" fill="#ffffff" transform="matrix(2.7057812213897705,0,0,2.7057812213897705,127.60966160198568,165.95385794818253)"><path d="M4.45 14.71L3.39 14.71L2.58 6.30L2.58 6.30Q2.49 6.94 2.40 7.63L2.40 7.63L2.40 7.63Q2.31 8.32 2.18 9.26L2.18 9.26L2.18 9.26Q2.04 10.21 1.86 11.52L1.86 11.52L1.86 11.52Q1.68 12.82 1.41 14.71L1.41 14.71L0.49 14.71L2.10 3.19L3.37 3.19L3.95 11.63L3.95 11.63Q4.00 11.24 4.06 10.84L4.06 10.84L4.06 10.84Q4.12 10.43 4.19 9.93L4.19 9.93L4.19 9.93Q4.26 9.44 4.35 8.82L4.35 8.82L4.35 8.82Q4.44 8.20 4.55 7.40L4.55 7.40L4.55 7.40Q4.66 6.59 4.80 5.56L4.80 5.56L4.80 5.56Q4.94 4.52 5.12 3.19L5.12 3.19L6.06 3.19L4.45 14.71ZM6.55 14.71L5.49 14.71L7.10 3.19L8.16 3.19L6.55 14.71ZM10.74 14.71L7.62 14.71L9.23 3.19L10.29 3.19L8.82 13.66L10.88 13.66L10.74 14.71ZM14.52 14.71L11.40 14.71L13.01 3.19L16.06 3.19L15.90 4.27L13.92 4.27L13.36 8.32L14.76 8.32L14.60 9.38L13.20 9.38L12.60 13.66L14.66 13.66L14.52 14.71Z"></path></g><defs data-v-fde0c5aa=""><linearGradient data-v-fde0c5aa="" gradientTransform="rotate(25)" id="e8619ee0-36ee-4abc-bad4-1e77a0708af1" x1="0%" y1="0%" x2="100%" y2="0%"><stop data-v-fde0c5aa="" offset="0%" stop-color="#ffffff" stop-opacity="1"></stop><stop data-v-fde0c5aa="" offset="100%" stop-opacity="1"></stop></linearGradient></defs><g data-v-fde0c5aa="" id="1164f2e8-15ad-443e-ac63-cd201a601be2" stroke="none" fill="url(#e8619ee0-36ee-4abc-bad4-1e77a0708af1)" transform="matrix(2.778252601623535,0,0,2.778252601623535,9.234270773395796,-27.651737019373982)"><path d="M52.5 55.563c7 0 11.063-7.688 11.063-7.688s-3.03 4.188-10.5 4.188c-5.438 0-9.75-8.188-20.125-8.188-8.485 0-14.375 8.583-20.826 8.583C8.861 52.458 3.875 48 3.875 48s2.813 7.563 9 7.563c9.625 0 13.313-5.844 20.25-5.844 8.188 0 9.813 5.844 19.375 5.844zm24.667-9.48c-7.323 0-10 7.917-10 7.917s4.322-3.042 9.625-2.167c4.542.75 9.042 6.083 20.667 5.333-4.85-2.15-13.271-11.083-20.292-11.083zm-.542 9.48c-8.688 0-15.537 5.165-22.688 5.063s-9.625-4.5-17.75-4.5c-5.188 0-6.688 5.188-6.688 5.188s1.929-2.25 5.625-2.25c5.188 0 11.058 7.25 19 7.25 12.438 0 17.375-7 22.875-7 4.75 0 10.688 3.75 10.688 3.75s-4.062-7.501-11.062-7.501z"></path></g>
          </svg>
        </a>
      </div>
      <div className='my-5 w-25 bg-white rounded-3 mx-auto p-4'>
        <h3 className='text-center'>Sign in</h3>
        <p className='text-center'>Sign in your accout to continue</p>
        <div className='error text-center'>
          {message.message === 'Rejected' ? 'You are not an Admin' : ''}
        </div>
        <form action='' onSubmit={formik.handleSubmit}>
          <CustomInput type='text' name='email' label='Email Address' id='email' onCh={formik.handleChange('email')} onBl={formik.handleBlur('email')} val={formik.values.email} />
          <div className='error mt-2'>
            {formik.touched.email && formik.errors.email}
          </div> 
          <CustomInput type='password' name='password' label='Password' id='password' onCh={formik.handleChange('password')} onBl={formik.handleBlur('password')} val={formik.values.password} />
          <div className='error mt-2'>
            {formik.touched.password && formik.errors.password}
          </div> 
          <div className='mb-3 text-end'>
            <Link to='/forgot-password' className='text-decoration-none'>Forgot Password?</Link>
          </div> 
          <button className='boder-0 px-3 py-2 text-white fw-bold w-100 text-center text-decoration-none fs-5' style={{background: '#013476'}} type='submit'>Sign in</button>
          <div className='mb-3 text-end'>
            <p>New here?</p>
            <Link to='/sign-up' className='text-decoration-none'>Create Account</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
